<div class="row animated fadeIn">
  <div class="col-md-12">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h4 class="mb-0"><a href="javascript:void(0);" routerLink="/contacts/contacts-list"><span
            class="mdi mdi-arrow-left"></span></a>Contact Details</h4>
    </div>

    <div class="card">
      <div class="card-body new-detail-page">
        <form [formGroup]="registerForm">
          <h5 class="mb-3 pb-2 border-bottom mt-3 text-green"> Contact Information</h5>
          <div class="form-row odd">
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Contact Name:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.ContactName}}</p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Mobile:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.Mobile}}</p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Landline:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.Landline}}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="form-row even">
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Whatsapp Number
                  <a href="javascript:void(0);">
                    <img src="assets/images/whatsapp-2.png" width="20" alt="">
                  </a>
                </label>
                <div class="col-sm-8 col">
                  <a href="https://wa.me/919896162500" target="_blank">
                    <p class="pt-2 mb-0 font-weight-bold">{{formdata?.WhatsappNumber}}</p>
                  </a>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Email:</label>
                <div class="col-sm-8 col">
                  <a href="mailto:{{formdata['Email']}}">
                    <p class="pt-2 mb-0 font-weight-bold">{{formdata?.Email}}</p>
                  </a>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Country:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.CountryName}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row odd">
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">State:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.StateName}}</p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">City:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.CityName}}</p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Date of Birth:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.DateOfBirth}}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="form-row even">
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Address1:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.Address1}}</p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Address2:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.Address2}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row even">
          </div>

          <h5 class="mb-3 pb-2 border-bottom mt-3 text-green">Company Information</h5>
          <div class="form-row odd">
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Company:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.CompanyName}}</p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Designation:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.DesignationName}}</p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label"> Contact Owner:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.UserName}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row even">
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label"> Nationality:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.NationalityName}}</p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Religion:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.ReligionName}}</p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label"> Language:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.LanguageName}}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="form-row odd">
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label"> Pro Reservation:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.ProReservationName}}</p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Gender:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.Gender}}</p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label"> Factory Visit Type/Comments:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.FactoryVisitComments}}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="form-row even">
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label"> Comments:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.Comments}}</p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label"> VVIP:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold"> {{formdata?.IsVVIP == false ? "No": "Yes"}}</p>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label"> Factory Visit:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold"> {{formdata?.IsFactoryVisit == false ? "No": "Yes"}}</p>
                </div>
              </div>
            </div>
          </div>

          <h5 class="mb-3 pb-2 border-bottom mt-3 text-green">Status Remark</h5>

          <div class="form-row odd">

            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Status:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.StatusName}}</p>
                </div>
              </div>
            </div>

            <div class="form-group col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <label class="col-sm-4 col col-form-label">Remark:</label>
                <div class="col-sm-8 col">
                  <p class="pt-2 mb-0 font-weight-bold">{{formdata?.StatusRemark}}</p>
                </div>
              </div>
            </div>

          </div>

        </form>
      </div>
    </div>
  </div>
</div>